module.exports = __webpack_public_path__ + "img/african-grand-lodge.1cf62c38.png";